import React from 'react'
import useCustomerServicePageConfig from '../hooks/use-page-config'
import CustomerServiceLayoutDefault from '../layout/default'
import CSHeader from '../partials/header'
import StyledContent from '../../../leap/components/styled-content'

const CustomerServiceContentPage = () => {
    const pageConfig = useCustomerServicePageConfig()
    const {name, description, showTitle, content} = pageConfig

    return (
        <CustomerServiceLayoutDefault maxWidth={'100%'} px={{base: 4, lg: '6.5rem', xl: 0}}>
            {showTitle && <CSHeader headline={name} subline={description} />}
            <StyledContent
                content={content?.body.replace(/<\/?h3>/g, (match) => match.replace('h3', 'h2'))}
                backgroundColor="stokkeCore.white"
                w={{base: '100%', '2xl': '96rem'}}
                py={{base: 8, lg: 10}}
                px={{base: 4, lg: '5.25rem', '2xl': '16rem'}}
            />
        </CustomerServiceLayoutDefault>
    )
}

export default CustomerServiceContentPage
